import { LoadingOutlined } from "@ant-design/icons"
import { Spin, Tooltip, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import Button from "../../../../../Components/Button"
import Spinner from "../../../../../Components/Spinner"
import { RoutesPaths } from "../../../../../constants/user-routes"
import { highAccessRoles } from "../../../../../Utils/permission"
import { RECEIPT_PAGE_STATE } from "../../../constants/receipt-status-mapping"
import EmptyLookups from "../EmptyLookups"
import GhostTable from "../GhostTable"

import styles from "./styles.module.less"

const { Title, Text } = Typography

export const PageStateOverlay = ({ pageState, firstEnrollBlocked, activeColumns, onEnroll }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const baRoleId = useSelector((s) => s.auth?.userInfo?.ba_role?.id)

  const isPrivileged = highAccessRoles.includes(baRoleId)
  const canEnroll = isPrivileged && !firstEnrollBlocked

  const enrollTooltip = !isPrivileged
    ? t("Allows for Owner or Administrator roles")
    : firstEnrollBlocked
      ? t("The balance should be more than $1 to enroll")
      : ""

  const handleEnroll = () => {
    if (onEnroll) return onEnroll()
    navigate(RoutesPaths.receipts._configure)
  }

  return (
    <div className={styles.wrap} data-testid={`deflect-user-${pageState}`}>
      <GhostTable activeColumns={activeColumns} />
      <div className={styles.overlay}>
        {!pageState && (
          <div className={styles.state}>
            <Spinner />
            <Text type="secondary">{t("No receipts found...")}</Text>
          </div>
        )}

        {pageState === RECEIPT_PAGE_STATE.NOT_ENROLLED && (
          <div className={styles.card}>
            <EmptyLookups />
            <Tooltip title={enrollTooltip}>
              <Button
                type="primary"
                onClick={handleEnroll}
                disabled={!canEnroll}
                className={styles.cta}
                data-testid="deflect-user-enroll-btn"
              >
                {t("Enroll now")}
              </Button>
            </Tooltip>
          </div>
        )}

        {pageState === RECEIPT_PAGE_STATE.PENDING && (
          <div className={styles.state}>
            <Spinner />
            <Title level={5} className={styles.title}>
              {t("Enrollment in progress")}
            </Title>
            <Text
              type="secondary"
              className={styles.text}
              data-testid="deflect-user-pending-description"
            >
              {t(
                "We're processing your enrollment request. This usually takes 1 business day. We'll email you when Digital Receipt is active for your account."
              )}
            </Text>
            <span className={styles.pill}>
              <Spin
                indicator={<LoadingOutlined spin className={styles.pillSpinner} />}
                size="small"
              />
              {t("Pending...")}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
